import './LogisticServiceDetailsTabContentSkeletonLoader.scss';

const LogisticServiceDetailsTabContentSkeletonLoader = () => {
  return (
    <div className="LogisticServiceDetailsTabContentSkeletonLoader">
      <div className="sectionTitleSkeleton animationLoader" />
      <div className="informationBlockSkeleton LogisticServiceOrganizationInformationSkeletonLoader">
        <div className="countrySkeleton">
          <div className="countryLabelSkeleton animationLoader" />
          <div className="countryFieldSkeleton animationLoader" />
        </div>
        <div className="fieldAndLabelSkeleton">
          <div className="labelSkeleton animationLoader" />
          <div className="mediumField animationLoader" />
        </div>
        <div className="fieldAndLabelSkeleton">
          <div className="labelSkeleton animationLoader" />
          <div className="mediumField animationLoader" />
        </div>
        <div className="textAreaSkeleton">
          <div className="labelSkeleton animationLoader" />
          <div className="mediumField animationLoader" />
        </div>
      </div>
      <div className="dividerLine" />
      <div className="sectionTitleSkeleton animationLoader" />
      <div className="informationBlockSkeleton LogisticServiceRequesterInformationSkeletonLoader">
        <div className="fieldAndLabelSkeleton">
          <div className="labelSkeleton animationLoader" />
          <div className="smallField animationLoader" />
        </div>
        <div className="fieldAndLabelSkeleton">
          <div className="labelSkeleton animationLoader" />
          <div className="smallField animationLoader" />
        </div>
        <div className="phoneSkeleton">
          <div className="labelSkeleton animationLoader" />
          <div className="fields">
            <div className="countryFieldSkeleton animationLoader" />
            <div className="mediumField animationLoader" />
          </div>
        </div>
        <div className="fieldAndLabelSkeleton">
          <div className="labelSkeleton animationLoader" />
          <div className="mediumField animationLoader" />
        </div>
      </div>
      <div className="dividerLine" />
      <div className="sectionTitleSkeleton animationLoader" />
      <div className="LogisticServicePaymentSectionSkeletonLoader">
        <div className="paymentOptionsContainer">
          {[0, 1, 2].map(i => {
            return (
              <div className="paymentOption" key={`paymentOption${i}`}>
                <div className="circleSkeleton animationLoader"></div>
                <div className="textSkeleton animationLoader"></div>
              </div>
            );
          })}
        </div>
        <div className="informationBlockSkeleton">
          <div className="fieldAndLabelSkeleton">
            <div className="labelSkeleton animationLoader" />
            <div className="smallField animationLoader" />
          </div>
          <div className="fieldAndLabelSkeleton">
            <div className="labelSkeleton animationLoader" />
            <div className="smallField animationLoader" />
          </div>
          <div className="fieldAndLabelSkeleton">
            <div className="labelSkeleton animationLoader" />
            <div className="smallField animationLoader" />
          </div>
          <div className="downloadButtonSkeleton">
            <div className="downloadButton animationLoader" />
            <div className="buttonTextSkeleton animationLoader" />
          </div>
          <div className="downloadButtonSkeleton">
            <div className="downloadButton animationLoader" />
            <div className="buttonTextSkeleton animationLoader" />
          </div>
        </div>
      </div>
      <div className="dividerLine" />
      <div className="sectionTitleSkeleton animationLoader" />
      <div className="LogisticServiceDatesAndProgrammingDetailsSkeletonLoader">
        <div className="datesFormContainer">
          <div className="smallField animationLoader" />
          <div className="smallField animationLoader" />
          <div className="smallField animationLoader" />
          <div className="smallField animationLoader" />
          <div className="smallField animationLoader" />
        </div>
        <div className="commentsSkeleton animationLoader" />
      </div>
      <div className="dividerLine" />
      <div className="sectionTitleSkeleton animationLoader" />
      <div className="LogisticServiceDocumentsSkeletonLoader informationBlockSkeleton">
        <div className="downloadButtonSkeleton">
          <div className="downloadButton animationLoader" />
          <div className="buttonTextSkeleton animationLoader" />
        </div>
        <div className="downloadButtonSkeleton">
          <div className="downloadButton animationLoader" />
          <div className="buttonTextSkeleton animationLoader" />
        </div>
        <div className="downloadButtonSkeleton">
          <div className="downloadButton animationLoader" />
          <div className="buttonTextSkeleton animationLoader" />
        </div>
        <div className="downloadButtonSkeleton">
          <div className="downloadButton animationLoader" />
          <div className="buttonTextSkeleton animationLoader" />
        </div>
      </div>
      <div className="whitespaceAtTheBottom w-10 h-10" />
    </div>
  );
};

export default LogisticServiceDetailsTabContentSkeletonLoader;
